"use strict";

exports.__esModule = true;
exports.default = void 0;

var functionInvocator = function functionInvocator() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function () {
    return funcs.filter(function (func) {
      return typeof func === 'function';
    }).forEach(function (func) {
      return func();
    });
  };
};

var _default = functionInvocator;
exports.default = _default;